import styled from 'styled-components';
import { Heading2Mixin, FootnoteMixin } from '@qover/typography';
import { FaqMinusIconMixin, FaqPlusIconMixin } from './FaqIcons';

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    &.row {
      flex-direction: row;
      justify-content: space-between;
      max-width: 100%;

      ul + ul {
        margin-left: 20px;
      }
    }
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    max-width: 50%;
  }
`;

export const Header = styled.h2`
  ${Heading2Mixin};
  color: ${({ theme }) => theme.colors.textQuote()};

  p {
    margin: 0;
  }
`;

export const ListDocs = styled.ul`
  ${FootnoteMixin};
  font-weight: bold;
  list-style: none;
  margin: 0;
  padding-top: 12px;
  width: 100%;

  li + li {
    padding-top: 12px;
  }

  li {
    display: flex;

    svg {
      margin-right: 12px;
      min-width: 20px;

      path,
      use {
        fill: ${({ theme }) => theme.colors.textQuote()};
      }
    }

    a {
      color: ${({ theme }) => theme.colors.textQuote()};
    }
  }
`;

export const ListQuestions = styled.ul`
  color: ${({ theme }) => theme.colors.textQuote()};
  list-style: none;
  margin: 0;

  li + li {
    border-top: solid 1px ${({ theme }) => theme.colors.textQuote(0.1)};
  }

  li {
    cursor: pointer;
    .content > *:last-child {
      margin-bottom: 20px;
    }
    &.active {
      .content {
        padding: 0 20px 0 40px;
        height: auto;
        max-height: 1000px;
        transition: 0.6s all linear;
      }
    }

    .content {
      padding: 0 20px 0 40px;
      font-size: 16px;
      font-weight: normal;
      max-height: 0;
      overflow: hidden;
      transition: 0.3s all linear;
    }
  }

  @media (max-width: 670px) {
    li:first-child {
      margin-top: 20px;
    }

    li {
      margin-bottom: 10px;
    }

    li:last-child {
      margin: 0;
    }
  }

  .markdown li {
    box-shadow: none;
    margin: 1em;
  }
  .markdown ul li {
    list-style-type: disc;
  }
  .markdown ol {
    padding: 0;
  }
  .markdown ol li {
    list-style-type: decimal;
  }
  a {
    color: ${({ theme }) => theme.colors.secondary()};
  }
`;

export const Question = styled.div`
  ${FaqPlusIconMixin};
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: left 10px top 15px;
  font-size: 16px;
  font-weight: 500;
  outline: 0;
  padding: 15px 50px 15px 40px;
  position: relative;

  &.active {
    ${FaqMinusIconMixin};
    background-repeat: no-repeat;
    background-size: 20px 20px;
    background-position: left 10px top 15px;
  }

  > svg {
    fill: ${({ theme }) => theme.colors.secondary()};
    margin-top: -6px;
    position: absolute;
    right: 20px;
    top: 50%;
    width: 14px;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  max-width: 960px;
  width: 100%;
  padding: 40px 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    &.row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;
